"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebflowClient = void 0;
const Client_1 = require("./api/resources/token/client/Client");
const Client_2 = require("./api/resources/sites/client/Client");
const Client_3 = require("./api/resources/collections/client/Client");
const Client_4 = require("./api/resources/pages/client/Client");
const Client_5 = require("./api/resources/scripts/client/Client");
const Client_6 = require("./api/resources/assets/client/Client");
const Client_7 = require("./api/resources/webhooks/client/Client");
const Client_8 = require("./api/resources/forms/client/Client");
const Client_9 = require("./api/resources/users/client/Client");
const Client_10 = require("./api/resources/accessGroups/client/Client");
const Client_11 = require("./api/resources/products/client/Client");
const Client_12 = require("./api/resources/orders/client/Client");
const Client_13 = require("./api/resources/inventory/client/Client");
const Client_14 = require("./api/resources/ecommerce/client/Client");
class WebflowClient {
    constructor(_options) {
        this._options = _options;
    }
    get token() {
        var _a;
        return ((_a = this._token) !== null && _a !== void 0 ? _a : (this._token = new Client_1.Token(this._options)));
    }
    get sites() {
        var _a;
        return ((_a = this._sites) !== null && _a !== void 0 ? _a : (this._sites = new Client_2.Sites(this._options)));
    }
    get collections() {
        var _a;
        return ((_a = this._collections) !== null && _a !== void 0 ? _a : (this._collections = new Client_3.Collections(this._options)));
    }
    get pages() {
        var _a;
        return ((_a = this._pages) !== null && _a !== void 0 ? _a : (this._pages = new Client_4.Pages(this._options)));
    }
    get scripts() {
        var _a;
        return ((_a = this._scripts) !== null && _a !== void 0 ? _a : (this._scripts = new Client_5.Scripts(this._options)));
    }
    get assets() {
        var _a;
        return ((_a = this._assets) !== null && _a !== void 0 ? _a : (this._assets = new Client_6.Assets(this._options)));
    }
    get webhooks() {
        var _a;
        return ((_a = this._webhooks) !== null && _a !== void 0 ? _a : (this._webhooks = new Client_7.Webhooks(this._options)));
    }
    get forms() {
        var _a;
        return ((_a = this._forms) !== null && _a !== void 0 ? _a : (this._forms = new Client_8.Forms(this._options)));
    }
    get users() {
        var _a;
        return ((_a = this._users) !== null && _a !== void 0 ? _a : (this._users = new Client_9.Users(this._options)));
    }
    get accessGroups() {
        var _a;
        return ((_a = this._accessGroups) !== null && _a !== void 0 ? _a : (this._accessGroups = new Client_10.AccessGroups(this._options)));
    }
    get products() {
        var _a;
        return ((_a = this._products) !== null && _a !== void 0 ? _a : (this._products = new Client_11.Products(this._options)));
    }
    get orders() {
        var _a;
        return ((_a = this._orders) !== null && _a !== void 0 ? _a : (this._orders = new Client_12.Orders(this._options)));
    }
    get inventory() {
        var _a;
        return ((_a = this._inventory) !== null && _a !== void 0 ? _a : (this._inventory = new Client_13.Inventory(this._options)));
    }
    get ecommerce() {
        var _a;
        return ((_a = this._ecommerce) !== null && _a !== void 0 ? _a : (this._ecommerce = new Client_14.Ecommerce(this._options)));
    }
}
exports.WebflowClient = WebflowClient;
